import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fcbbc47a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fcbbc47a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbbc47a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\fenxijunya-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcbbc47a')) {
      api.createRecord('fcbbc47a', component.options)
    } else {
      api.reload('fcbbc47a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fcbbc47a&scoped=true", function () {
      api.rerender('fcbbc47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/bargain/bargainList/index.vue"
export default component.exports